import { Injectable } from '@angular/core';
import { EmailInfo } from '../classes/email-info'
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SendEmailService {

  emailInfo: EmailInfo = {};
  constructor(private http: HttpClient) {}

  sendEmail(firstName: string, lastName: string, emailAddress: string, phoneNumber: string, message: string): Observable<any> {
    const payload = {
      operation: 'sendEmail',
      firstName: firstName,
      lastName: lastName,
      emailAddress: emailAddress,
      phoneNumber: phoneNumber,
      message: message
    };
    
    return this.http.post("https://kas1tg4g4e.execute-api.us-east-1.amazonaws.com/dev/send-email", payload).map((response: Response) => response.json())
  }
}
